module.exports = __webpack_public_path__ + "img/Upscaler04.a02edb3d.png";